<!-- <div class="w-100 d-flex justify-content-center mb-2">
    <button class="btn btn-outline-secondary rounded-0 me-3 mt-4 mb-2" type="button"
        (click)="setFlasherManualControlImageOff()">
        Blinker aus</button>

    <button [disabled]="selectedAqChannel === undefined  || selectedAQControlStellcode === 0"
        class="btn btn-outline-success rounded-0 me-3 mt-4 mb-2" type="button" (click)="setFlasherManualControlOn()">
        Blinker an</button>
    <button [disabled]="selectedAqChannel === undefined" class="btn btn-outline-danger rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="turnFlasherControlOff()">
        Steuerung entfernen</button>

</div> -->

<div class="w-100 d-flex justify-content-center mb-2">
    <mat-slide-toggle [(ngModel)]="function" color="primary" (change)="onToggleChange()">
        {{ function ? 'aktiv' : 'inaktiv' }}
    </mat-slide-toggle>
</div>

<!-- {{selectedDoChannel | json}} -->
<div class="w-100 d-flex justify-content-center mb-2">
    <button [disabled]="selectedAqChannel === undefined" class="btn btn-outline-success rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="createFlasherControl()"> Manuelle
        Steuerung erstellen</button>
    <button [disabled]="selectedAqChannel === undefined" class="btn btn-outline-danger rounded-0 me-3 mt-4 mb-2"
        type="button" (click)="turnFlasherControlOff()"> Manuelle
        Steuerung entfernen</button>

</div>